import Rails from '@rails/ujs';

const initStripe = () => {
    const stripeFormContainer = document.getElementById('card-element');
    console.log({stripeFormContainer})
    if (!stripeFormContainer) {
        return;
    }
    const stripeToken = stripeFormContainer.getAttribute('data-stripe');
    const stripe = Stripe(stripeToken, {locale: gon.locale});

    // Create an instance of Elements.
    const elements = stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    const style = {
        base: {
            color: '#32325d',
            lineHeight: '18px',
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
                color: '#aab7c4'
            }
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
        },
    };

    // Create an instance of the card Element.
    const card = elements.create('card', {style: style, hidePostalCode: true});

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element');
    // Handle real-time validation errors from the card Element.
    card.addEventListener('change', function(event) {
        const displayError = document.getElementById('card-errors');
        if (event.error) {
            displayError.textContent = event.error.message;
        } else {
            displayError.textContent = '';
        }
        
        requestId = null;
    });

    // Handle form submission.
    const form = document.getElementById('stripe_form');
    
    // Generate unique request ID for idempotency
    let requestId = null;
    
    form.addEventListener('submit', function(event) {
        event.preventDefault();
        event.stopPropagation();

        // Generate request ID only once per form submission
        if (!requestId) {
            requestId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        }

        const email = $('#user_email').val();
        stripe.createPaymentMethod({
            type: 'card',
            card: card,
            billing_details: {
                email: email
            }
        }).then(function(result) {
            if (result.error) {
                const errorElement = document.getElementById('card-errors');
                errorElement.textContent = result.error.message;
            } else {
                $(form).find('input[name="stripe[payment_method]"], input[name="stripe[card]"], input[name="stripe[request_id]"]').remove();
                
                $(form)
                    .append($('<input type="hidden" name="stripe[payment_method]">').val(result.paymentMethod.id))
                    .append($('<input type="hidden" name="stripe[card]">').val(JSON.stringify(result.paymentMethod.card)))
                    .append($('<input type="hidden" name="stripe[request_id]">').val(requestId));
                
                Rails.handleRemote.call(form, event);
            }
        });
        return false;
    }, true);
    
    // Handle AJAX response for 3D Secure
    $(document).on('ajax:success', '#stripe_form', function(event) {
        const [data, status, xhr] = event.detail;
        
        // Only reset requestId on final success
        if (data.success) {
            requestId = null;
        }
        
        handlePaymentResponse(data);
    });
    
    $(document).on('ajax:error', '#stripe_form', function(event) {
        const [data, status, xhr] = event.detail;
        
        // Don't reset requestId on error - keep it for retry with same card
        
        const errorElement = document.getElementById('card-errors');
        // Parse JSON response if needed
        let errorData = data;
        if (typeof data === 'string') {
            try {
                errorData = JSON.parse(data);
            } catch (e) {
                // If not JSON, use as is
            }
        }
        errorElement.textContent = errorData.error_message || 'エラーが発生しました';
    });

    // Handle payment response
    const handlePaymentResponse = (data) => {
        if (data.requires_action && data.payment_intent_client_secret) {
            handle3DSecure(data.payment_intent_client_secret, data.intent_type || 'payment');
        } else if (data.processing) {
            setTimeout(() => {
                confirmPaymentWithServer(data.payment_intent_id, data.intent_type || 'payment');
            }, 3000);
        } else if (data.success && data.redirect_url) {
            window.location.href = data.redirect_url;
        } else {
            console.error('Unexpected response format:', data);
        }
    };

    // Handle 3D Secure authentication
    const handle3DSecure = async (clientSecret, intentType) => {
        const result = intentType === 'setup'
            ? await stripe.confirmCardSetup(clientSecret)
            : await stripe.confirmCardPayment(clientSecret);
        
        if (result.error) {
            // Show error to customer
            const errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
            // Reset requestId on 3D Secure failure to allow new attempt
            requestId = null;
        } else {
            // Payment succeeded, confirm with server
            const intentId = intentType === 'setup' ? result.setupIntent.id : result.paymentIntent.id;
            confirmPaymentWithServer(intentId, intentType);
        }
    };


    // Confirm payment status with server
    const confirmPaymentWithServer = (paymentIntentId, intentType) => {
        // Get role from form if it exists
        const role = $('#stripe_form input[name="role"]').val() || '';
        
        $.ajax({
            url: `/${gon.locale}/my-page/cards/confirm_payment`,
            method: 'POST',
            data: {
                payment_intent_id: paymentIntentId,
                intent_type: intentType,
                role: role,
                authenticity_token: Rails.csrfToken()
            },
            dataType: 'json',
            success: function(response) {
                handlePaymentResponse(response);
            },
            error: function(xhr) {
                console.error(xhr);
                const errorElement = document.getElementById('card-errors');
                errorElement.textContent = 'エラーが発生しました';
            }
        });
    };
};

$(() => {
    initStripe();
});

window.initStripe = initStripe;
